import React, { useState, useRef } from 'react';
import { Form, FormControl } from 'react-bootstrap';
import url from '../../../../api/cms/url';
import { navigationIds } from '../../../../analyticsTags';

const Search = () => {
  const inputEl = useRef<any>(null);
  const [show, setShow] = useState(false);

  return (
    <Form
      inline
      className="search-block ml-lg-auto"
      onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
        if (inputEl.current.value) {
          window.location.assign(
            `${url.searchUrl}${encodeURIComponent(inputEl.current.value)}`,
          );
        }
        e.preventDefault();
      }}>
      <fieldset>
        <Form.Label className="sr-only">Search</Form.Label>
        <FormControl
          id="Search_Nav"
          type="text"
          ref={inputEl}
          className={`${show ? ' show' : ''}`}
        />
      </fieldset>
      <button
        id={navigationIds.navigationSearch}
        type="button"
        value="Search"
        className={`${show ? ' active-search' : ''}`}
        onClick={() => {
          setShow(!show);
          if (!show) {
            inputEl.current.focus();
          }
        }}>
        <i className="fa fa-search" aria-hidden="true"/>
      </button>
    </Form>
  );
};

export default Search;
